<template>

    <TronHeader style="margin-bottom:48px" />

    <main class="container header-overlap account-new address-container address-page">
        <div class="row">
            <div class="col-md-12">
                <div style="">
                    <div class="address-top">
                        <div class="address-title">

                            <!-- Address Header Desktop -->
                            <div class="address-title-box">
                                <div class="address-title-name">
                                    <span>账户信息</span>
                                </div>
                                <div class="address-title-address-wrap flex-start">
                                    <span class="address-container address-title-address-cont address-all-container ">
                                        <div class="react-contextmenu-wrapper">
                                            <span>
                                                <div class="truncate-ellipsis">
                                                    <span>
                                                        <div class="d-flex address-link-wrap " style="align-items: center;">
                                                            <span class="text-truncate address-link address-text ">
                                                                <span class="d-inline-flex align-items-center">
                                                                    <img class="tron-square-24px tron-border-radius-100  tron-mr-8px d-inline-flex align-items-center" :src="require('@/assets/images/download.svg')" alt="">
                                                                    <div class="ellipsis_box ellipsis_box_all">
                                                                        <div class="d-inline-block line-ellipsis">{{ this.address }}</div>
                                                                    </div>
                                                                </span>
                                                            </span>
                                                            <div class="labelShow"></div>
                                                            <span id="copyAddress" class="tron-ml-4px ellipsis_box_copy " style="cursor: pointer;" @click="copyToClipboard(address)">
                                                                <svg class="icon tron-icon copy-icon tron-font-size-12px" aria-hidden="true" style="color: rgb(145, 151, 157);">
                                                                    <use xlink:href="/static/media/icons.svg#icon-copy-dark-gray"></use>
                                                                </svg>
                                                            </span>
                                                            <span id="qrCode" class="tron-ml-3 qrcode-box tron-cursor-pointer">
                                                                <svg class="icon tron-icon tron-font-size-10px" aria-hidden="true" style="font-size: 12px;">
                                                                    <use xlink:href="/static/media/icons.svg#icon-qrcode-new"></use>
                                                                </svg>
                                                            </span>                                                            
                                                        </div>
                                                    </span>
                                                </div>
                                            </span>
                                        </div>
                                    </span>
                                </div>
                            </div>

                            <!-- Address Header Mobile -->
                            <div class="mobile-address-title hidden-PC">
                                <span class="address-container   ">
                                    <div class="react-contextmenu-wrapper">
                                        <span>
                                            <div class="truncate-ellipsis">
                                                <span>
                                                    <div class="d-flex address-link-wrap " style="align-items: center;">
                                                        <a class="text-truncate address-link " href="/address/{{ this.address }}">
                                                            <div class="ellipsis_box">{{ this.address }}</div>
                                                        </a>
                                                        <div class="labelShow"></div>
                                                    </div>
                                                </span>
                                            </div>
                                        </span>
                                    </div>
                                    <span class="new-address-content-menu-wrap">
                                        <nav role="menu" tabindex="-1" class="react-contextmenu dropdown-menu show new-address-content-menu" style="z-index: 899; position: fixed; opacity: 0; pointer-events: none;"></nav>
                                    </span>
                                </span>
                            </div>                            
                        </div>

                        <!-- Create Date and Recent Activity -->
                        <div class="activity-statistics">
                            <div class="activity-item">
                                <div class="activity-title">
                                    <div class="d-inline-block ">
                                        <div class="question-mark">
                                            <svg class="icon tron-icon question-mark-icon" aria-hidden="true">
                                                <use xlink:href="/static/media/icons.svg#icon-icon-ask"></use>
                                            </svg>
                                        </div>
                                    </div>
                                    <span class="ml-1">
                                        <span>最近的活动</span> (UTC) </span>
                                </div>
                                <span class="activity-num">
                                    <span>{{ this.accountRecentOn }}</span>
                                </span>
                            </div>
                            <div class="activity-item">
                                <div class="activity-title">
                                    <div class="d-inline-block ">
                                        <div class="question-mark">
                                            <svg class="icon tron-icon question-mark-icon" aria-hidden="true">
                                                <use xlink:href="/static/media/icons.svg#icon-icon-ask"></use>
                                            </svg>
                                        </div>
                                    </div>
                                    <span class="ml-1">
                                        <span>创建于</span> (UTC) </span>
                                </div>
                                <span class="activity-num">
                                    <ul class="list-unstyled m-0">
                                        <li class="d-flex flex-wrap mobile-no-flex">
                                            <span>{{ this.accountCreatedOn }}</span>
                                        </li>
                                    </ul>
                                </span>
                            </div>
                            <div class="time-setting-wrapper">
                                <svg class="icon tron-icon icon-block-age" aria-hidden="true">
                                    <use xlink:href="/static/media/icons.svg#icon-block-age"></use>
                                </svg>
                            </div>
                        </div>
                    </div>

                    <div class="info-wrap">
                        <div class="address-info address-info-new">
                            <div class="address-asset-wrap">
                                <div class="address-overview">
                                    <span class="address-overview-title">
                                        <span>总资产</span>
                                        <div class="go-to-asset">
                                            <svg class="icon tron-icon tron-font-size-10px" aria-hidden="true">
                                                <use xlink:href="/static/media/icons.svg#icon-icon-right-colorless"></use>
                                            </svg>
                                        </div>
                                    </span>
                                    <div class="address-asset">
                                        <span class="address-asset-num">${{ formatCurrency(usdtOnlyUSD) ?? 0.00}}</span>
                                        <span class="address-asset-value">
                                            <span>≈ <span id="JskFBoiCwRfGbHxpeEgdylan">{{this.accountAssetsTRX}}&nbsp; <span class="">TRX</span>
                                                </span>
                                            </span>
                                        </span>
                                    </div>                                    
                                </div>                                                               
                            </div>

                            <table class="table m-0">
                                <tbody>
                                    <tr>
                                        <th>
                                            <span class="question-mark-wrap">
                                                <div class="d-inline-block ">
                                                    <div class="question-mark">
                                                        <svg class="icon tron-icon question-mark-icon" aria-hidden="true">
                                                            <use xlink:href="/static/media/icons.svg#icon-icon-ask"></use>
                                                        </svg>
                                                    </div>
                                                </div>
                                            </span>
                                            <span class="mr-1">
                                                <span>TRX 质押</span> / <span>平衡</span>: </span>
                                        </th>
                                        <td>
                                            <a href="#">
                                                <span style="color: rgb(194, 54, 49);">
                                                    <span>{{ this.trxStaked }}</span>&nbsp;TRX&nbsp; </span>
                                            </a> / <span>{{ this.trxBalance }}</span> TRX
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <span class="question-mark-wrap">
                                                <div class="d-inline-block ">
                                                    <div class="question-mark">
                                                        <svg class="icon tron-icon question-mark-icon" aria-hidden="true">
                                                            <use xlink:href="/static/media/icons.svg#icon-icon-ask"></use>
                                                        </svg>
                                                    </div>
                                                </div>
                                            </span>
                                            <span class="mr-1">
                                                <span>交易</span>: </span>
                                        </th>
                                        <td class="d-flex mobile-no-flex mobile-transaction">
                                            <a class="active" aria-current="page" href="/">
                                                <span class="colorRed">
                                                    <span>{{ this.trxTransactions }}</span>&nbsp; </span>
                                            </a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <span class="question-mark-wrap">
                                                <div class="d-inline-block ">
                                                    <div class="question-mark">
                                                        <svg class="icon tron-icon question-mark-icon" aria-hidden="true">
                                                            <use xlink:href="/static/media/icons.svg#icon-icon-ask"></use>
                                                        </svg>
                                                    </div>
                                                </div>
                                            </span>
                                            <span class="mr-1">
                                                <span>接送服务</span>: </span>
                                        </th>
                                        <td class="d-flex mobile-no-flex mobile-transaction">
                                            <div class="d-flex flex-wrap">
                                                <a href="/">
                                                    <div class="colorRed">
                                                        <span>{{ this.accountTransfers }}</span>&nbsp;
                                                    </div>
                                                </a>
                                                <div class="d-flex align-items-center">
                                                    <span class="ml-1">(</span>
                                                    <svg class="icon tron-icon transfer-arrow-down tron-font-size-12px" aria-hidden="true">
                                                        <use xlink:href="/static/media/icons.svg#icon-transfer-success-arrow"></use>
                                                    </svg>
                                                    <span>
                                                        <span>{{ this.accountTransfersIn }}</span>
                                                    </span>&nbsp; <svg class="icon tron-icon transfer-arrow-up tron-font-size-12px" aria-hidden="true">
                                                        <use xlink:href="/static/media/icons.svg#icon-transfer-fail-arrow"></use>
                                                    </svg>
                                                    <span>
                                                        <span>{{ this.accountTransfersOut }}</span>
                                                    </span>&nbsp; <span>)</span>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <span class="question-mark-wrap">
                                                <div class="d-inline-block ">
                                                    <div class="question-mark">
                                                        <svg class="icon tron-icon question-mark-icon" aria-hidden="true">
                                                            <use xlink:href="/static/media/icons.svg#icon-icon-ask"></use>
                                                        </svg>
                                                    </div>
                                                </div>
                                            </span>
                                            <span class="mr-1">
                                                <span>总带宽</span>: </span>
                                        </th>
                                        <td class="td-progress">
                                            <span class="remain-new">
                                                <i>
                                                    <span>可用的: </span>
                                                    <span class="contract-address-text_underline">{{ this.trxBandwidthRemain }}</span>
                                                </i>&nbsp;/&nbsp; <a href="/">
                                                    <span style="color: rgb(194, 54, 49);">{{ this.trxBandwidthLimit }}</span>
                                                </a>
                                            </span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <span class="question-mark-wrap">
                                                <div class="d-inline-block ">
                                                    <div class="question-mark">
                                                        <svg class="icon tron-icon question-mark-icon" aria-hidden="true">
                                                            <use xlink:href="/static/media/icons.svg#icon-icon-ask"></use>
                                                        </svg>
                                                    </div>
                                                </div>
                                            </span>
                                            <span class="mr-1">
                                                <span>总能量</span>: </span>
                                        </th>
                                        <td class="td-progress">
                                            <span class="remain-new">
                                                <span class="tron-font-default-color">
                                                    <span>可用的</span>: </span>
                                                <span class="contract-address-text_underline tron-font-default-color">{{ this.trxEnergyRemain }}</span>&nbsp;/&nbsp; <a href="#">
                                                    <span style="color: rgb(194, 54, 49);">{{ this.trxEnergyLimit }}</span>
                                                </a>
                                            </span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <span class="question-mark-wrap">
                                                <div class="d-inline-block ">
                                                    <div class="question-mark">
                                                        <svg class="icon tron-icon question-mark-icon" aria-hidden="true">
                                                            <use xlink:href="/static/media/icons.svg#icon-icon-ask"></use>
                                                        </svg>
                                                    </div>
                                                </div>
                                            </span>
                                            <span class="mr-1">
                                                <span>投票数</span>: </span>
                                        </th>
                                        <td class="td-progress">
                                            <span class="remain-new">
                                                <i>
                                                    <span>已投票</span>: </i>
                                                <span class="colorRed vote-detail"> 0</span>&nbsp;/&nbsp;0 </span>
                                            <span></span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <span class="question-mark-wrap">
                                                <div class="d-inline-block ">
                                                    <div class="question-mark">
                                                        <svg class="icon tron-icon question-mark-icon" aria-hidden="true">
                                                            <use xlink:href="/static/media/icons.svg#icon-icon-ask"></use>
                                                        </svg>
                                                    </div>
                                                </div>
                                            </span>
                                            <span class="mr-1">
                                                <span>无人认领的投票奖励</span>: </span>
                                        </th>
                                        <td>
                                            <ul class="list-unstyled m-0">
                                                <li class="d-flex align-items-center">
                                                    <span id="maBGqxbrdpfcwAFMgoCiLelD">0&nbsp; <span class="">TRX</span>
                                                    </span>
                                                </li>
                                            </ul>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div class="asset-overview-table">
                            <a-tabs class="ant-tabs ant-tabs-top ant-tabs-card" default-active-key="wallet" style="margin-top:24px; margin-bottom: 24px;">
                                <a-tab-pane key="wallet">
                                    <template #tab>
                                        钱包 ({{ this.tokens.length }})
                                    </template>
                                    <div class="token-balance-has-more" style="margin-top: 24px;">
                                        <div class="token-balance-wrap-new" id="token-balance-list">
                                            <div v-for="(token, index) in this.tokens" :key="index" class="token-balance-item">
                                                <div class="token-balance-item-left">
                                                    <b class="token-logo token-img-top" style="margin-right: 5px;">
                                                        <img :src="token.tokenLogo" width="20" height="20" />
                                                    </b>
                                                    <div class="token-desc">
                                                        <div class="token-name">
                                                            <a href="#"> {{ token.tokenName }} ({{ token.tokenAbbr }}) </a>
                                                            <span v-if="token.tokenType === 'trc20'" class="token-tag badge badge-success">TRC20</span>
                                                            <span v-if="token.tokenType === 'trc10'" class="token-tag badge badge-danger">TRC10</span>
                                                        </div>
                                                        <div class="token-id" v-if="token.tokenType === 'trc10' && token.tokenId !== '_'">
                                                            ID: {{ token.tokenId }}
                                                        </div>
                                                        <div v-if="token.tokenType === 'trc20'" class="token-id">
                                                            <a :href="`/address/${token.tokenId}`" class="address-link">
                                                                {{ formatAddress(token.tokenId) }}
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="token-balance-item-right">
                                                    <div v-if="token.amount" class="token-num">
                                                        {{ token.amount }}
                                                        <span v-if="token.tokenAbbr === 'trx'"> (可用的: {{ token.amount }}) </span>
                                                    </div>                                                    
                                                    <div v-else class="token-num">
                                                        {{ formatQuantity(token.balance, token.tokenDecimal) }}
                                                        <span v-if="token.tokenAbbr === 'trx'"> (可用的: {{ formatQuantity(token.balance, token.tokenDecimal) }}) </span>
                                                    </div>

                                                    <div class="token-value">
                                                        ≈ {{ token.amountInUsd ? `$${token.amountInUsd.toFixed(2)}` : '--' }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </a-tab-pane>

                                <a-tab-pane key="portfolio" tab="文件夹">
                                    <div></div>
                                </a-tab-pane>

                                <a-tab-pane key="approval" tab="赞同">
                                    <div></div>
                                </a-tab-pane>
                            </a-tabs>                            
                        </div>
                    </div>
                </div>

                <div class="profit-box address-profit">
                    <div class="profit-main loading">
                        <svg class="icon tron-icon" aria-hidden="true">
                            <use xlink:href="/static/media/icons.svg#icon-icon-loding"></use>
                        </svg>
                    </div>
                    <div class="common-profit-wapper" id="profitWrapper">
                        <a v-if="adBannerData" :href="adBannerData.ad_link" target="_blank" rel="noopener">
                            <img :src="`/static/${adBannerData.ad_image}`" alt="Banner Advertisement" style="width:100%; height:auto;" />
                        </a>
                    </div>
                </div>

                <div id="tab_data_list" class="card mt-3 new-list-style-body address-table-pagination list-style-body ">
                    <!-- <TabNavigation :address="address" /> -->
                    <div class="tab-content">
                        <router-view :key="address" />
                    </div>
                </div>
            </div>
        </div>    
    </main>

</template>

<script>
    import axios from 'axios';
    import dayjs from 'dayjs';    
    import TronHeader from '@/components/TronHeader.vue';
    import TabNavigation from '@/components/TabNavigation.vue'
    import { Tabs, message } from 'ant-design-vue';    
    import { h } from 'vue';

    export default {
        name: "TronAddress",
        components: {
            TronHeader,
            TabNavigation,
            'a-tabs': Tabs,
            'a-tab-pane': Tabs.TabPane,
        },
        props: {
            address: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                loading: false,
                loadingOverview: true,
                addressOverview: {},
                addressTokens: {},

                accountCreatedOn: '',
                accountRecentOn: '',
                accountTransfers: 0,
                accountTransfersIn: 0,
                accountTransfersOut: 0,

                accountAssetsUSD: 0,
                accountAssetsTRX: 0,
                trxStaked: 0,
                trxBalance: 0,
                trxTransactions: 0,
                trxBandwidthLimit: 0,
                trxBandwidthRemain: 0,
                trxEnergyLimit: 0,
                trxEnergyRemain: 0,
                tokens: [],

                adBannerData: null,

            }
        },
        computed: {
            usdtOnlyUSD() {
                if (!Array.isArray(this.tokens)) return 0;
                return this.tokens                
                .filter(t => (t.tokenAbbr && t.tokenAbbr.toUpperCase().includes('USDT')) ||
                            (t.tokenName && t.tokenName.toUpperCase().includes('TETHER')))
                .reduce((sum, t) => sum + (Number(t.amountInUsd) || 0), 0);
            }
        },
        watch: {
            '$route'(to) {            
                const address = to.params.address || to.query.address;
                this.getAddressData(this.address);
            }
        },
        async mounted() {
            if(this.address)
            {                
                await this.getAddressData(this.address);
            }

            
            fetch('/ads_banner.json')
            .then(res => res.json())
            .then(data => {                
                this.adBannerData = data;
            })
            .catch(err => {
                console.error("Failed to load ad JSON:", err);
            });                      
        },
        methods: {
            async getAddressData(currentAddress)
            {
                const addressData = await this.fetchAccountOverview(currentAddress);
                if(addressData)
                {
                    this.addressOverview = addressData;                    

                    //Account Creation and Activity
                    this.accountCreatedOn = dayjs(this.addressOverview.date_created).format('YYYY-MM-DD HH:mm:ss');
                    this.accountRecentOn = dayjs(this.addressOverview.latest_operation_time).format('YYYY-MM-DD HH:mm:ss');

                    //Account Transfers Summary
                    this.trxTransactions = this.addressOverview.totalTransactionCount.toLocaleString();
                    this.accountTransfers = this.addressOverview.transactions.toLocaleString();
                    this.accountTransfersIn = this.addressOverview.transactions_in.toLocaleString();
                    this.accountTransfersOut = this.addressOverview.transactions_out.toLocaleString();

                    // TRX Staked / Balance
                    const tmpTRXBalance = this.getTrxBalanceInfo(this.addressOverview);                    
                    this.trxStaked = tmpTRXBalance.stakedTRX.toLocaleString();
                    this.trxBalance = tmpTRXBalance.totalTRX.toLocaleString();

                    this.trxBandwidthRemain = this.addressOverview.bandwidth.freeNetRemaining;
                    this.trxBandwidthLimit = this.addressOverview.bandwidth.freeNetLimit;

                    this.trxEnergyRemain = this.addressOverview.bandwidth.energyRemaining;
                    this.trxEnergyLimit = this.addressOverview.bandwidth.energyLimit;

                }

                const accountTokens = await this.fetchAccountTokens(currentAddress);
                if(accountTokens)
                {
                    this.addressTokens = accountTokens;
                    //console.log(this.addressTokens.data);

                    this.tokens = this.addressTokens.data.filter(token => token.tokenCanShow);

                    let totalUsd = 0;
                    let totalTrx = 0;

                    this.addressTokens.data.forEach(token => {
                        if (token.amountInUsd) {
                            totalUsd += token.amountInUsd;
                        }

                        if (token.amount) {
                            totalTrx += parseFloat(token.amount);
                        }
                    });

                    this.accountAssetsUSD = totalUsd.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                    this.accountAssetsTRX = totalTrx.toLocaleString(undefined, { minimumFractionDigits: 6, maximumFractionDigits: 6 });
                    
                }
            },
            getTrxBalanceInfo(data) {
                const SUN_TO_TRX = 1_000_000;
                const stakedTRX = data.totalFrozenV2 / SUN_TO_TRX;                
                const liquidTRX = data.balance / SUN_TO_TRX;                
                const totalTRX = stakedTRX + liquidTRX;

                return {
                    stakedTRX: stakedTRX.toFixed(2),
                    totalTRX: totalTRX.toFixed(2)
                };
            },
            formatCurrency(n) {
                return Number(n || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            },
            formatQuantity(balance, decimals) {
                if (!balance || !decimals) return '0';
                const num = Number(balance) / Math.pow(10, decimals);
                return num.toLocaleString(undefined, {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 6,
                });
            },
            formatAddress(address) {
                if (!address) return '';
                return address.length > 12 ? `${address.slice(0, 6)}...${address.slice(-6)}` : address;
            },
            async delayedFetch(url, delayMs, config = {}) {
                await new Promise(resolve => setTimeout(resolve, delayMs));
                return axios.get(url, config);
            },
            async fetchAccountOverview(currentAddress) {
                try {                    
                    const url = `https://apilist.tronscanapi.com/api/accountv2?address=` + currentAddress;

                    const response = await this.delayedFetch(url, 1500);
                    return response.data;
                } catch (err) {
                    this.error = 'Failed to fetch TRX Stake';
                    console.error(err);
                    return null;
                }
            },
            async fetchAccountTokens(currentAddress) {
                try { 
                    const apiKey = 'b6f6c21f-776c-4c0e-9c94-dfe40c7e4421';                   
                    const url = `https://apilist.tronscanapi.com/api/account/tokens?address=` + currentAddress + `&start=0&limit=20&token=&hidden=0&show=0&sortType=0&sortBy=0`;

                    const response = await this.delayedFetch(url, 1500, {
                        headers: {
                            'TRON-PRO-API-KEY': apiKey
                        }
                    });
                    return response.data;
                } catch (err) {
                    this.error = 'Failed to fetch TRX Stake';
                    console.error(err);
                    return null;
                }
            },

            copyToClipboard(address) {
                navigator.clipboard.writeText(address).then(() => {                    
                    this.$message.success({
                        content: h('div', [
                            h('div', { style: 'font-weight: bold; word-break: break-all; color: black;' }, 'Copied to Clipboard ✅'),
                            h('div', { style: 'font-weight: bold; word-break: break-all; color: black;' }, address),
                        ]),
                        duration: 2,
                    });
                }).catch(err => {
                    this.$message.error("复制失败");
                    console.error(err);
                });
            },
        }
    }

</script>

<style src="@/assets/styles/address.css" lang="css"></style>
<style src="@/assets/styles/address.1109.css" lang="css"></style>
<style src="@/assets/styles/address.1224.css" lang="css"></style>
<style src="@/assets/styles/address.1965.css" lang="css"></style>
<style src="@/assets/styles/address.2162.css" lang="css"></style>
<style src="@/assets/styles/address.3027.css" lang="css"></style>
<style src="@/assets/styles/address.4846.css" lang="css"></style>
<style src="@/assets/styles/address.5148.css" lang="css"></style>
<style src="@/assets/styles/address.7563.css" lang="css"></style>
<style src="@/assets/styles/address.9803.css" lang="css"></style>
<style src="@/assets/styles/iconfont.css" lang="css"></style>

<style scoped>
    .loading-overlay {
        position: absolute;
        top: 0; left: 0;
        width: 100%;
        height: 100%;
        background: rgba(255, 255, 255, 0.6);
        z-index: 10;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 8px;
    }

    .spinner {
        border: 4px solid #eee;
        border-top: 4px solid #3498db;
        border-radius: 50%;
        width: 28px;
        height: 28px;
        animation: spin 1s linear infinite;
    }

    @keyframes spin {
        to {
            transform: rotate(360deg);
        }
    }

    .badge-danger {
        color: #fff;
        background-color: #dc3545;
    }
    .badge-secondary {
        color: #fff;
        background-color: #6c757d;
    }
    .badge-info {
        color: #fff;
        background-color: #17a2b8;
    }
    .badge-warning {
        color: #1f2d3d;
        background-color: #ffc107;
    }
    .badge-success {
        color: #fff;
        background-color: #28a745;
    }
    .badge {
        display: inline-block;        
        font-size: 75%;
        font-weight: 700;
        line-height: 1;
        text-align: center;
        white-space: nowrap;
        vertical-align: baseline;
        margin-right: 5px;        
        transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
    }
    
</style>    